import { usePost } from "@/api/lib/integration";
import type { RequestMaklerVollmacht, MaklervollmachtStatus } from "@/api/maklerVollmacht/types";

export const requestMaklerVollmacht = usePost<RequestMaklerVollmacht, { status: MaklervollmachtStatus }>('/api/maklervollmacht/request-signature')
